<template>
  <div class="footer-nav">
    <div class="footer-nav-b">
      <div class="footer-main clearfix">
        <div class="footer-ba">
          <div class="logo-icon">
            <img src="../../src/assets/images/icon/360logo-w.png" alt="" />
          </div>
          <div>
            <a href="https://www.bcpai.com/yyzz"
              target="_blank">上海百昌科技集团有限公司</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a
              href="https://www.bcpai.com/jypzzs" target="_blank">拍卖经营许可证</a>
          </div>
          <div>
            Copyright&nbsp;&nbsp;©2018-2023&nbsp;&nbsp;百昌拍卖.All rights
            reserved.
          </div>
          <div>
            <a href="https://beian.miit.gov.cn/#/Integrated/index"
              target="_blank">沪ICP备18016056号-11</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011202007656"
              target="_blank">沪公网安31011202007656号</a>
          </div>
          <div>
            <a href="https://www.bcpai.com/privacy"
              target="_blank">用户协议</a>&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;<a
              href="https://www.bcpai.com/conceal"
              target="_blank">隐私协议</a>&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;<span @click="feedbackShow()"
              style=" cursor:pointer ">意见反馈</span>
          </div>
          <a href="https://www.bcpai.com/aqzs" target="_blank">
            信息系统安全等级保护备案证明
          </a>
        </div>
        <div class="footer-zx">
          <div class="zx-t">
            <span>产品中心</span>
          </div>
          <div class="zx-t-m clearfix">
            <div class="zs-t-m-l">
              <div class="m-a">
                <a href="https://www.bcpai.com" target="_blank">百昌拍卖平台<span></span></a>
              </div>
              <!-- 25-3-12 remove -->
              <!-- <div class="m-a">
                <a href="https://www.bcpai.com/meansShop" target="_blank"
                  >资产小店<span></span
                ></a>
              </div> -->
              <div class="m-a">
                <a href="https://www.bcainpl.com/assessMap" target="_blank">百昌估值地图<span></span></a>
              </div>
              <div class="m-a">
                <a href="https://www.bcainpl.com/brief/" target="_blank">百昌找律师<span></span></a>
              </div>
              <div class="m-a">
                <a href="https://www.bczcc.com/" target="_blank">再查查<span></span></a>
              </div>
            </div>
            <div class="zs-t-m-l">
              <div class="m-a">
                <a href="https://www.bcyhl.com/" target="_blank">赢回来<span></span></a>
              </div>
              <div class="m-a">
                <a href="https://shouxihome.bcainpl.com/" target="_blank">首席<span></span></a>
              </div>
              <div class="m-a">
                <a href="https://www.bcainpl.com/steward/" target="_blank">楼管家<span></span></a>
              </div>
              <div class="m-a">
                <a href="https://shiye.bczcc.com/report" target="_blank">师爷AI大模型<span></span></a>
              </div>
              <!-- 25-3-12 remove -->
              <!-- <div class="m-a">
                <a href="https://console.bcnpl.com" target="_blank"
                  >百昌控制台<span></span
                ></a>
              </div> -->

            </div>
          </div>
        </div>
        <div class="footer-lx">
          <div class="zx-t">
            <span>联系我们</span>
          </div>
          <div class="lx-m">
            <div class="lx-item">
              <div class="item-t">
                <img src="../assets/images/components/kfdh.png" alt="" />
                <p>业务热线</p>
              </div>
              <div class="item-num">400-015-0005</div>
            </div>
            <div class="lx-item">
              <div class="item-t">
                <img src="../assets/images/components/ywhz.png" alt="" />
                <p>前台热线</p>
              </div>
              <div class="item-num">021-3388-5987</div>
            </div>
          </div>
        </div>
        <div class="footer-code">
          <img src="../assets/images/components/code.png" alt="" />
          <div class="code-txt">
            <p>扫码关注</p>
            <p>百昌科技集团</p>
          </div>
        </div>
        <div class="feedback-frame">
          <Feedback class="feedback" v-if="this.$store.state.isFeedbackShow" @isFeedback="feedbackHide()"></Feedback>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Feedback from "../components/feedback.vue";
export default {
  name: "footerNav",
  data() {
    return {
      isFeedbackShow: false,
    };
  },
  components: {
    Feedback,
  },
  methods: {
    // 显示意见反馈
    feedbackShow() {
      document.documentElement.style.height = 100 + "vh";
      document.documentElement.style.width = 100 + "vw";
      document.documentElement.style.overflow = "hidden";
      let isFeedbackShow = !this.$store.state.isFeedbackShow;
      this.$store.commit("UPSTATAFEEDBACK", isFeedbackShow);
    },
    // 隐藏意见反馈
    feedbackHide() {
      document.documentElement.style.height = 100 + "%";
      document.documentElement.style.overflow = "auto";
      this.$store.commit("UPSTATAFEEDBACK", false);
    },
  },
};
</script>

<style scoped lang="scss">
.footer-nav {
  min-width: 1200px;
  height: 500px;
  margin: 0 auto;

  .footer-nav-b {
    min-width: 1200px;
    height: 500px;
    margin: 0 auto;
    background-color: #464646;
  }

  .footer-main {
    position: relative;
    width: 1200px;
    margin: 0 auto;
    font-size: 14px;
    font-family: "SourceHanSansCN-Regular";
    color: #fefefe;
    line-height: 30px;

    .feedback-frame {
      width: 100%;
      height: 100%;

      .feedback {
        position: fixed;
        bottom: 0px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 999;
      }
    }

    .footer-ba {
      width: 477px;
      padding-top: 150px;
      padding-left: 50px;
      float: left;

      .logo-icon {
        width: 176px;
        height: 40px;
        overflow: hidden;
        margin-bottom: 18px;

        img {
          display: block;
          width: 230px;
          height: 40px;
        }
      }

      a,
      span {
        color: #fff;

        &:hover {
          color: #77cdff;
        }
      }
    }

    .footer-zx {
      padding-top: 140px;
      float: left;

      /*width: 207px;*/
      .zx-t {
        font-size: 18px;
        font-weight: bold;

        span {
          padding-bottom: 10px;
          border-bottom: 4px solid #77cdff;
        }
      }

      .zx-t-m {
        padding-top: 40px;

        .zs-t-m-l {
          float: left;
          width: 150px;
        }

        .m-a {
          line-height: 18px;
          height: 18px;
          margin-bottom: 20px;

          a {
            color: #fff;
            font-size: 13px;
            position: relative;
            cursor: pointer;

            span {
              width: 3px;
              height: 3px;
              border-radius: 3px;
              position: absolute;
              background-color: #fff;
              left: -9px;
              top: 50%;
              margin-top: -1.5px;
            }

            &:hover {
              color: #77cdff;

              span {
                background-color: #77cdff;
              }
            }
          }
        }
      }
    }

    .footer-lx {
      padding-top: 140px;
      float: left;

      .zx-t {
        font-size: 18px;
        font-weight: bold;

        span {
          padding-bottom: 10px;
          border-bottom: 4px solid #77cdff;
        }
      }

      .lx-m {
        padding-top: 40px;

        .lx-item {
          padding-bottom: 16px;

          .item-t {
            display: flex;
            align-items: center;
            margin-bottom: 14px;

            img {
              display: block;
              margin-right: 8px;
            }
          }

          .item-num {
            line-height: 16px;
            font-size: 16px;
          }
        }
      }
    }

    .footer-code {
      float: right;
      padding-top: 140px;
      padding-right: 20px;

      img {
        width: 160px;
        height: 160px;
        display: block;
      }

      .code-txt {
        padding-top: 23px;
        font-size: 14px;
        color: #fefefe;
        line-height: 18px;
        text-align: center;
      }
    }
  }
}
</style>
